import React from "react";
import WeightInput from "./WeightInput";

function Weight(props) {
  const { weightName, ...otherProps } = props;

  return <WeightInput name={weightName} {...otherProps} />;
}

export default Weight;
